import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, ValidationErrors, ValidatorFn } from '@angular/forms';
import { GeocodingModel } from 'src/app/models/location.model';
import { ExternalService } from 'src/app/services/external/external.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import * as stringSimilarity from "string-similarity";


@Component({
    templateUrl: './place-selector.component.html',
    styleUrls: ['./place-selector.component.scss'],
    selector: 'place-selector',
    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          multi:true,
          useExisting: PlaceSelectorComponent
        },
        {
            provide: NG_VALIDATORS, 
            useExisting: forwardRef(() => PlaceSelectorComponent),
            multi: true,
        },
    ]
})

export class PlaceSelectorComponent implements ControlValueAccessor {
    // form = new UntypedFormGroup({
    //     city: new UntypedFormControl('')
    //   });

    // Data passed in by componentProps
    options:GeocodingModel[] = [];

    optionsFromFavorites:GeocodingModel[] = [];
    // optionsInput:any[] = [{name:'courses',key:'FJSDKFL'},{name:'dodo',key:'jklfjqmf'},{name:'rando',key:'jkmjfqdf'}];
    optionSelected = {};
    field:string = 'name';
    newValue:string;
    canCreate = false;
    multiSelect = false;
    displayList = false;

    onChange = (value) => {};
    onTouched = () => {};
    onValidationChange: any = () => {};

    touched = false;

    @Input()
    geoCode = true;

    @Input()
    value:GeocodingModel | any ;
    // @Input('value')
    // set value(value:GeocodingModel|any){
    //     this._value = value;
    //     this.city = value.address.city;
    //     this.onValidationChange();
    //     console.log('value set',this._value);
    // }
    // _value:GeocodingModel;

    @Input()
    dataService: Promise<any>;

    @Input()
    title:string;

    @Input()
    placeholder:string;

    @Input()
    favorites:GeocodingModel[] = [];

    _locationTypes = ['houseNumber','street','locality','addressBlock'];
    @Input('locationTypes')
    set locationTypes(value:[]){
        this._locationTypes = value;
        this.onValidationChange();
        // console.log('locationtype set',this._locationTypes);
    }
    // locationTypes = ['houseNumber','street'];

    disabled = false;

    @Output() valueChanged = new EventEmitter<GeocodingModel>();


    constructor(private externalService:ExternalService,public formBuilder: UntypedFormBuilder, private utils:UtilsService) {
        // this.setForm();
    }

    setForm(){
        // this.form = this.formBuilder.group({
        //     city:['']
        // });
    }
  
    ionViewWillEnter() {

    }

    ngOnInit(){

    }

    filterByLabel(input:string){
        stringSimilarity.com
    }

    onInputChange(event){
        console.log(event);
        this.switchTouched();
        const inputValue = event.target.textContent;
        if(this.canCreate){
            this.newValue = inputValue; //event.data.value;
        }
        if((!this.value || this.value.label !== inputValue ) && inputValue){
            
            if(this.favorites){
                const favoritesFiltered = this.favorites.filter(favorite => {
                    const similarity =  stringSimilarity.compareTwoStrings(favorite.label.toLowerCase(),inputValue.toLowerCase());
                    console.log(similarity,favorite.label,inputValue);
                    return similarity  > 0.15;
                });
                this.optionsFromFavorites = favoritesFiltered;
            }

            this.externalService.geocodeLocationWithHere(inputValue).then(results => {
                this.options = results.filter(item => this._locationTypes.includes(item.resultType));
                if(this.options.length>0){
                    this.displayList = true;
                }
                else{
                    this.displayList = false;
                }
                // console.log('options', inputValue, results, this._locationTypes, this.options);
            })
        }
        // else if(this.options){
        //     const array = this.optionsInput.map(item=>item.name);
        //     const results = stringSimilarity.findBestMatch(inputValue,array).ratings;
        //     this.options = results.filter(item=>{
        //         return item.rating >= 0.5
        //     }).map(item => item.target)
        //     console.log(array, results,this.options);
        // }

    }

    async onFocusOut(event:any){
        console.log("focus out",event);
        await this.utils.sleep(200);
        this.displayList = false;
        //this.options = [];
        this.writeValue(this.value);
    }

    onFocus(){
        console.log("focus");
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    onOptionSelected(item:GeocodingModel| any){
        console.log('option selected',item, this.value);
        this.writeValue(item);
        this.onChange(item);
        this.onValidationChange();
        this.valueChanged.emit(item);
        this.options = [];
        this.displayList = false;
        this.optionsFromFavorites = [];
        this.switchTouched();
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
        // this.form.disable();
    }

    writeValue(value: GeocodingModel| any) {
        console.log('write value',value);
        if(value){
            this.value = value;
            // this.form.patchValue(value.address);
        }
    }
    
    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    switchTouched() {
        if (!this.touched) {
          this.onTouched();
          this.touched = true;
        }
        else{
            this.touched = false;
        }
    }

    validate(control?: AbstractControl): ValidationErrors {
        const validation = this.validateGeocodingType(this.value, this._locationTypes);
        const result = (validation?null:{invalidLocation:true});
        console.log('validation result', result);
        return result;
    }
  
    validateGeocodingType(value:GeocodingModel,locationTypes){
        return value && locationTypes.includes(value.resultType)
    }

    registerOnValidatorChange?(fn: () => void): void {
        this.onValidationChange = fn;
    }

    inputValidator(): ValidatorFn  {
        return (control:AbstractControl) : ValidationErrors | null => {
            if(!this.value){
                return {label:{value:false}}
            }
            else if (!this._locationTypes.includes(this.value.resultType)){
                return {label:{value:this.value.label}}
            }
            else {
                return null
            }
        };
    }
  }